const AUTH_TYPES = {
    sick_admin: 'sick_admin',
    vaca_admin: 'vaca_admin'
}
export default AUTH_TYPES